import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumns from "../../../../Core/ConfigureColumns/ConfigureColumns";
import ListLayout from "../../../../Core/Layout/ListLayout";
import { usePostUserLogsMutation } from '../../../../store/api/userManagementApi';
import ExportCSV from '../../../../Core/Export/ExportCSV'
const Lpntable = () => {
    const navigate = useNavigate();
    const pageSize = 12;
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [userLogsData, setUserLogsData] = useState({ records: [], total_no_of_records: 0 });
    const [postUserLogs] = usePostUserLogsMutation();
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const handleSaveColumns = (selectedFields) => {
        setSelectedColumns(selectedFields);
    };

    const filtersConfig = [
        { name: 'Si No', label: 'Si No', width: '5%' },

        { name: 'user', label: 'User', width: '12%' },
        {
            name: 'operation',
            label: 'Operation',
            width: '10.7%',
            type: 'select',
            options: [
                { value: 'Login', label: 'Login' },
                { value: 'Logout', label: 'Logout' },
            ]
        },

        {
            name: 'is_active',
            label: 'Is active',
            width: '10.7%',
            type: 'select',
            options: [
                { value: 'true', label: 'True' },
                { value: 'false', label: 'False' },
            ]
        },


        {
            name: 'last_login_range',
            label: 'Last Login Range',
            type: 'date-range',
            width: '16%'
        },
        {
            name: 'logout_range',
            label: 'Last Logout Range',
            type: 'date-range',
            width: '16%'
        }
    ];

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
    };

    const columns = useMemo(() => [
        {
            header: "SI No.",
            name: "SI No.",
            accessor: "id",
            width: '7%',
            cellRenderer: (row, rowIndex) => rowIndex + 1 + (pageSize * (currentPage - 1)),
            sortable: false
        },
        {
            header: "User",
            name: "user",
            accessor: "user",
            width: '19%',
            sortable: true
        },
        {
            header: "Operation",
            name: "operation",
            accessor: "operation",
            width: '16%',
            sortable: true
        },
        {
            header: "Active",
            name: "is_active",
            accessor: "is_active",
            width: '13%',
            cellRenderer: (row) => row.is_active ? "Yes" : "No",
            sortable: true
        },
        {
            header: "Last Login",
            name: "last_login",
            accessor: "last_login",
            width: '20%',
            sortable: true
        },
        {
            header: "Logout",
            name: "logout",
            accessor: "logout",
            width: '20%',
            sortable: true
        },
        {
            header: "Company",
            name: "company",
            accessor: "company",
            width: '15%',
            sortable: true
        }
    ], [currentPage]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",

            onClick: () => setShowExportPopup(true),
        }
    ];

    useEffect(() => {
        const fetchLogs = async () => {
            setLoading(true);
            try {
                // Base payload
                const payload = {
                    start: pageSize * (currentPage - 1),
                    page_length: pageSize,
                };

                // Dynamically add only non-empty filters
                const activeFilters = Object.entries(filters)
                    .filter(([_, v]) => v !== "" && v !== null && v !== undefined)
                    .reduce((acc, [key, value]) => {
                        acc[key] = value;
                        return acc;
                    }, {});

                const response = await postUserLogs({
                    ...payload,
                    ...activeFilters,
                }).unwrap();

                setUserLogsData({
                    records: response.result.records || [],
                    total_no_of_records: response.result.filtered_count || 0
                });
            } catch (error) {
                console.error("Error fetching user logs:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();
    }, [currentPage, filters, postUserLogs]);


    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "User Management" },
                    { label: "Login Logs", style: { color: '#270B79' } }
                ]}
                actionButtons={actionButtons}
            >
                <SearchFilters
                    filtersConfig={filtersConfig}
                    onFilterChange={handleFilterChange}
                    onSettingsToggle={() => setShowColumnConfig(true)}
                />

                <Table
                    columns={columns}
                    data={userLogsData.records}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={userLogsData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
            </ListLayout>
            {showExportPopup && (
                <ExportCSV
                    doctype="API Login Tracker"
                    onClose={() => setShowExportPopup(false)}
                />
            )}

            <ConfigureColumns
                show={showColumnConfig}
                onClose={() => setShowColumnConfig(false)}
                onSave={handleSaveColumns}
                docType="API Login Tracker"
                defaultSelected={columns}
            />
        </div>
    );
};

export default Lpntable;
